import React from 'react'
import type { Invoice } from '../../../../types'
import { createColumnHelper } from '@tanstack/react-table'
import { TranslatedText } from '@staccx/i18n'
import { getConsolidateInvoiceDescription } from '../../../../utils/getConsolidateInvoiceDescription'
import { formatDate } from '@staccx/bento'

export default function invoiceReportTableData(chosenCompany?: string) {
  const columnHelper = createColumnHelper<Invoice>()
  return [
    columnHelper.accessor('invoiceNo', {
      id: 'invoiceNo',
      meta: { alignmentType: 'string' },
      header: () => <TranslatedText i18nKey={'INVOICE_NO'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => row.getValue() || ''
    }),
    columnHelper.accessor('consolidateInvoiceCode', {
      id: 'consolidateInvoiceCode',
      meta: { alignmentType: 'string' },
      header: () => (
        <TranslatedText i18nKey={'CONSOLIDATED_AGREEMENT'}>{(value) => <span>{value}</span>}</TranslatedText>
      ),
      cell: (row) => row.getValue() || ''
    }),
    columnHelper.accessor('postingDate', {
      id: 'postingDate',
      header: () => <TranslatedText i18nKey={'INVOICE_POSTING_DATE'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => row.getValue() || '',
      meta: { alignmentType: 'date' }
    }),
    columnHelper.accessor('consolidateDescription', {
      id: 'consolidateDescription',
      header: () => (
        <TranslatedText i18nKey={'INVOICE_CONSOLIDATE_DESCRIPTION'}>{(value) => <span>{value}</span>}</TranslatedText>
      ),
      cell: (row) => row.getValue() || '',
      meta: { alignmentType: 'string' }
    }),
    columnHelper.accessor('billToName', {
      id: 'billToName',
      header: () => <TranslatedText i18nKey={'INVOICE_BILL_TO_NAME'}>{(value) => <span>{value}</span>}</TranslatedText>,
      cell: (row) => row.getValue() || '',
      meta: { alignmentType: 'string' }
    })
  ]
}
